<script>
import AppFooterLink from "@/components/AppFooterLink.vue";
export default {
  name: "AppFooter",
  components: { AppFooterLink },
};
</script>
<template>
  <footer>
    <AppFooterLink />
    <hr />
    <div class="pobistuff">
      <p>© 2023 Home Décor | Developed by Pobi Casaul</p>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
hr {
  width: 70%;
  margin: 0 auto;
}

.pobistuff {
  clear: both;
  padding: 11px 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;

  p {
    text-align: center;
    width: 100%;
  }
}
</style>
